import { ListingEditorVariantsLayout } from "@/components/listing-editor";
import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/supplier/$supplierId/listings/$listingId/$version/variants")({
  beforeLoad: () => ({
    breadcrumb: undefined,
  }),
  component: Page,
});

function Page() {
  return (
    <ListingEditorVariantsLayout>
      <Outlet />
    </ListingEditorVariantsLayout>
  );
}
